import React, { cloneElement } from 'react';
import Commons from '../../commons/Commons';
import FromServer from './FromServer';
import SpecificComponent from '../../commons/SpecificComponent';
import UsersListDrepturi from '../../commons/UsersListDrepturi'
import AddUserDrepturi from '../../commons/dialogs/AddUserDrepturi'
import { Fab, Button, Grid, Avatar } from '@material-ui/core';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import NewUserDrepturi from '../../commons/dialogs/NewUserDrepturi';
import CustomUserMenu from '../../commons/CustomUserMenu';

import { ReactComponent as Step1Green } from '../../Pics/iconsManagement/step1_green.svg';
import { ReactComponent as Step2 } from '../../Pics/iconsManagement/step2.svg';
import { ReactComponent as Step3Gray } from '../../Pics/iconsManagement/step3_gray.svg';
import { ReactComponent as Step4Gray } from '../../Pics/iconsManagement/step4_gray.svg';


export default class Useri extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listUsers: [],
            listAllUsers: [],
            strEmail: '',
            strNumeUser: '',
            isOpenInsert: false,
            listNivelResponsabil: new Utils().nvelResponsabilitate,
            displayDelete: false,
            isOpenNewUser: false,
            angajatInfo: {},
            isFirmaExterna: false,
            listDepartamente: [],
            activeStep: 1,
            steps: [
                { id: 0, done: true, icon: <Step1Green style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoProiect' },
                { id: 1, done: false, icon: <Step2 style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToUtilizatori' },
                { id: 2, done: false, icon: <Step3Gray style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoEtape' },
                { id: 3, done: false, icon: <Step4Gray style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoBuget' }
            ],
            userSelectat: '0',
            verifyEmail: '',
            parola: '',
            repetParola: '',
            vParola: '',
            toUpdate: false,
            isProgram: true,
            openList: false
        }
    }

    componentDidMount() {
        this.fromServer()
    }

    getIcons = () => {



        return this.state.steps.map((s, idx) => {

            return (


                <div key={idx} style={{ display: 'inline-block' }} onClick={this.props[s.goTo]}>
                    {s.icon}

                </div>
            )
        })
    }

    responsabilColor = (r) => {
        // console.log('r :', r);

        let nivel = 0
        switch (r) {
            case 1:
                nivel = '#1fce1f';
                break;
            case 2:
                nivel = '#e46d00';
                break;
            case 3:
                nivel = '#e81616'
                break;
            default:
                nivel = '#e81616'

        }

        return nivel
    }

    fromServer = async (a = null) => {
        let fs = new FromServer();

        let ws = new Ws()

        // ct(`select d.id as id_linie, d.doar_citire, d.nivel_responsabil, d.drepturi_extinse, d.id_utilizator as id ,
        //                                      a.nume, a.poza, a.cost_minut, u.email, u.firma, dep.nume as nume_departament from proiecte_drepturi d left join useri u on d.id_utilizator = u.id
        //                                      left join angajati a on u.id = a.id_user 
        //                                      left join angajati_departamente ad on ad.id_angajat = a.id
        //                                      left join departamente dep on dep.id = ad.id_departament
        //                                      where d.id_proiect = @p1 and isnull(u.inactiv,0) != 1 and isnull(d.sters,0) != 1 order by isnull(d.nivel_responsabil,3) asc`, {




        // let de = await ws.customSelect('select * from angajati_departamente', {
        //     p1: 1
        // })

        // // console.log('de :>> ', de);


        let getSocietate = await ws.customSelect('select * from setari', {
            p1: 'soc_code'
        })

        console.log('getSocietate :>> ', getSocietate);


        if (getSocietate.Succes) {

            //   `select d.id as id_linie, d.doar_citire, d.nivel_responsabil, d.drepturi_extinse, d.id_utilizator as id ,
            //                                      a.nume, a.poza, a.cost_minut, u.email, u.firma, dep.nume as nume_departament from proiecte_drepturi d left join useri u on d.id_utilizator = u.id
            //                                      left join angajati a on u.id = a.id_user 
            //                                      left join angajati_departamente ad on ad.id_angajat = a.id
            //                                      left join departamente dep on dep.id = ad.id_departament
            //                                      where d.id_proiect = @p1 and isnull(u.inactiv,0) != 1 and isnull(d.sters,0) != 1 order by isnull(d.nivel_responsabil,3) asc`

            let _users = ws.customSelect(`select
            d.id as id_linie, d.doar_citire, d.nivel_responsabil, d.drepturi_extinse,
            a.id , dep.id as id_departament, u.id as id_user,
            l.parola, l.parolac, l.email as email_logator, l.id_user_bazadate_proprie,
            ad.sef_departament,a.cnp,a.adresa,a.telefon,
            a.nume, a.poza, a.cost_minut, a.functie,a.oras, a.salariu, a.doc_fisa_postului,a.cv, u.email, u.firma, u.firma_externa, u.is_admin, dep.nume as nume_departament  from
            proiecte_drepturi d left join  useri u on d.id_utilizator = u.id
            left join angajati a on u.id = a.id_user 
            left join angajati_departamente ad on ad.id_angajat = a.id
            left join departamente dep on dep.id = ad.id_departament
            left join pm_logator.[dbo].useri l on u.id = l.id_user_bazadate_proprie
            where isnull(u.inactiv,0) != 1  and isnull(ad.inactiv,0) != 1 and isnull(d.sters,0) != 1  and d.id_proiect = @p3 order by a.nume asc`, {
                p1: 1,
                p2: getSocietate.Content.length > 0 ? Number(getSocietate.Content[0].val) : 1,
                p3: this.props.idproiect
            })

            let logator = await ws.customSelect(`select * from pm_logator.[dbo].useri `, { p1: 1 })



            console.log('logator :>> ', logator);

            // let angajati = await ws.customSelect('select * from angajati', {
            //     p1: 1
            // })

            // console.log('angajati :>> ', angajati);

            let departamente = ws.customSelect('select * from departamente where isnull(inactiv,0) != 1', {
                p1: 0
            })


            let programLucru = ws.customSelect('select * from program_lucru where 1 = @p1', {
                p1: 1
            })

            let _allUsers = ws.customSelect(`select
            u.id, u.email, u.nume, u.firma  from  useri u
            left join angajati a on u.id = a.id_user 
            left join angajati_departamente ad on ad.id_angajat = a.id
            left join departamente dep on dep.id = ad.id_departament
            left join pm_logator.[dbo].useri l on u.id = l.id_user_bazadate_proprie
            where isnull(u.inactiv,0) != 1 and u.id not in (select id_utilizator from proiecte_drepturi where id_proiect = @p3 and isnull(sters,0) != 1)  and l.id_societate_client = @p2 and isnull(ad.inactiv,0) != 1 order by a.nume asc`, {
                p1: 1,
                p2: getSocietate.Content.length > 0 ? Number(getSocietate.Content[0].val) : 1,
                p3:this.props.idproiect
            })

            let [users, dep, p, allUsers] = await Promise.all([_users, departamente, programLucru, _allUsers])



            console.log('users :', users);
            console.log('allUsers :>> ', allUsers);


            if (users.Succes && dep.Succes && p.Succes) {

                let time = new Utils()

                let program = [...p.Content]

                let listUsers = [...users.Content]


                for (let i = 0, n = listUsers.length; i < n; i++) {

                    let idx = program.findIndex(p => p.id_angajat === listUsers[i].id)

                    listUsers[i].selectat = false
                    listUsers[i].lu_start = idx !== -1 ? time.transformTimeFromSql(program[idx].lu_start) : '00:00'
                    listUsers[i].lu_end = idx !== -1 ? time.transformTimeFromSql(program[idx].lu_end) : '18:00'
                    listUsers[i].ma_start = idx !== -1 ? time.transformTimeFromSql(program[idx].ma_start) : '00:00'
                    listUsers[i].ma_end = idx !== -1 ? time.transformTimeFromSql(program[idx].ma_end) : '18:00'
                    listUsers[i].mi_start = idx !== -1 ? time.transformTimeFromSql(program[idx].mi_start) : '00:00'
                    listUsers[i].mi_end = idx !== -1 ? time.transformTimeFromSql(program[idx].mi_end) : '18:00'
                    listUsers[i].jo_start = idx !== -1 ? time.transformTimeFromSql(program[idx].jo_start) : '00:00'
                    listUsers[i].jo_end = idx !== -1 ? time.transformTimeFromSql(program[idx].jo_end) : '18:00'
                    listUsers[i].vi_start = idx !== -1 ? time.transformTimeFromSql(program[idx].vi_start) : '00:00'
                    listUsers[i].vi_end = idx !== -1 ? time.transformTimeFromSql(program[idx].vi_end) : '18:00'
                    listUsers[i].sa_start = idx !== -1 ? time.transformTimeFromSql(program[idx].sa_start) : '00:00'
                    listUsers[i].sa_end = idx !== -1 ? time.transformTimeFromSql(program[idx].sa_end) : '18:00'
                    listUsers[i].du_start = idx !== -1 ? time.transformTimeFromSql(program[idx].du_start) : '00:00'
                    listUsers[i].du_end = idx !== -1 ? time.transformTimeFromSql(program[idx].du_end) : '18:00'
                }



                if (a) {
                    let angajat = { ...this.state.angajatInfo }

                    let idx = listUsers.findIndex(i => i.id === a.id)

                    if (idx !== -1) {
                        let newAngajat = listUsers[idx]

                        this.setState({ angajatInfo: newAngajat })
                    }
                }





                let newUsers = []

                for (let i = 0, n = listUsers.length; i < n; i++) {
                    let idx = newUsers.findIndex(u => u.id_linie === listUsers[i].id_linie)

                    if (idx === -1) {
                        newUsers.push(listUsers[i])
                    }
                }





                this.setState({
                    listUsers: newUsers,
                    listAllUsers: allUsers.Content,
                    listDepartamente: dep.Content,
                    societate: getSocietate.Content[0]
                })

            }


        }





    }

    // fromServer = async () => {
    //     let fs = new FromServer();

    //     let ws = new Ws()

    //     let _users = fs.getUsers(this.props.idproiect)

    //     let _allUsers = fs.getAllUsers(this.props.idproiect)

    //     let departamente = ws.customSelect('select * from departamente where isnull(inactiv,0) != 1', {
    //         p1: 0
    //     })

    //     let [users, allUsers, dep] = await Promise.all([_users, _allUsers, departamente])



    //     console.log('users :', users);

    //     console.log('allUsers :', allUsers);


    //     let listUsers = users


    //     let newUsers = []

    //     for (let i = 0, n = listUsers.length; i < n; i++) {
    //         let idx = newUsers.findIndex(u => u.id_linie === listUsers[i].id_linie)

    //         if (idx === -1) {
    //             newUsers.push(listUsers[i])
    //         }
    //     }

    //     console.log('newUsers :>> ', newUsers);



    //     this.setState({
    //         listUsers: newUsers,
    //         listAllUsers: allUsers,
    //         listDepartamente: dep.Content
    //     })
    // }


    userClick = (e) => {
        // console.log('e :', e);
        this.setState({ displayDelete: this.state.displayDelete ? false : true })

    }


    changeCitire = (c) => {
        // console.log('c :', c);

        let citire = 0

        if (c.doar_citire === 1) {
            citire = 0
        } else {
            citire = 1
        }

        let where = {
            id_proiect: this.props.idproiect,
            id_utilizator: c.id
        }
        let objToUpdate = {
            doar_citire: citire
        }

        let fs = new FromServer();

        let update = fs.updateUserProject(objToUpdate, where)

        if (update) {

            let cloneUsers = [...this.state.listUsers]

            let idx = cloneUsers.findIndex(u => u.id === c.id)

            cloneUsers[idx].doar_citire = citire

            this.setState({ listUsers: cloneUsers })
        }

        // console.log('object :', objToUpdate);
    }

    changeExtins = (c) => {
        // console.log('c :', c);

        let drepturi_extinse = 0

        if (c.drepturi_extinse === 1) {
            drepturi_extinse = 0
        } else {
            drepturi_extinse = 1
        }

        let where = {
            id_proiect: this.props.idproiect,
            id_utilizator: c.id
        }
        let objToUpdate = {
            drepturi_extinse: drepturi_extinse
        }

        let fs = new FromServer();

        let update = fs.updateUserProject(objToUpdate, where)

        if (update) {

            let cloneUsers = [...this.state.listUsers]

            let idx = cloneUsers.findIndex(u => u.id === c.id)

            cloneUsers[idx].drepturi_extinse = drepturi_extinse

            this.setState({ listUsers: cloneUsers })
        }

        // console.log('object :', objToUpdate);
    }

    addUser = async (u) => {

        console.log('u :', u);

        let ws = new Ws()


        // console.log('val :>> ', val);
        let ls = new LocalStorage()

        let user = ls.GetUserData().InfoUser

        console.log('user :>> ', user);

        let fs = new FromServer();


        let userD = await ws.customSelect('select * from useri_drepturi where id_utilizator = @p1', {
            p1: user.IdUser
        })

        console.log('userD :>> ', userD);

        if (userD.Succes) {

            let uDrepturi = { ...userD.Content[0] }


            let objToInsert = {
                id_proiect: this.props.idproiect,
                id_utilizator: u.id,
                doar_citire: 0,
                drepturi_extinse: 0,
                asignat_de_user_id: user.IdUser,
                asignat_la_data: new Utils().updateSqlNow(),
                vede_financiar: uDrepturi.acces_extins_proiecte,
                edit_financiar: uDrepturi.acces_extins_proiecte,

                vede_toate_taskurile: uDrepturi.acces_extins_proiecte,
                editeaza_taskuri: uDrepturi.acces_extins_proiecte,

                vede_toate_etapele: uDrepturi.acces_extins_proiecte,
                editeaza_etape: uDrepturi.acces_extins_proiecte,

                gestioneaza_useri: uDrepturi.acces_extins_proiecte,

            }

            console.log('objToInsert :>> ', objToInsert);

            console.log('objToInsert :', objToInsert);


            let insert = await fs.insertUserProject(objToInsert)

            if (insert) {
                this.setState({ isOpenInsert: false }, () => {
                    this.fromServer()
                })
            }

        }









    }

    addUserNew = async (u) => {
        // console.log('u :', u);

        //   let val = ev.target.value

        //   console.log('val :>> ', val);


        let ws = new Ws()

        let ls = new LocalStorage()

        let user = ls.GetUserData().InfoUser

        let fs = new FromServer();

        let userD = await ws.customSelect('select * from useri_drepturi where id_utilizator = @p1', {
            p1: user.IdUser
        })

        console.log('userD :>> ', userD);

        if (userD.Succes) {

            let uDrepturi = { ...userD.Content[0] }


            let objToInsert = {
                id_proiect: this.props.idproiect,
                id_utilizator: u.id,
                doar_citire: 0,
                drepturi_extinse: 0,
                asignat_de_user_id: user.IdUser,
                asignat_la_data: new Utils().updateSqlNow(),
                vede_financiar: uDrepturi.acces_extins_proiecte,
                edit_financiar: uDrepturi.acces_extins_proiecte,

                vede_toate_taskurile: uDrepturi.acces_extins_proiecte,
                editeaza_taskuri: uDrepturi.acces_extins_proiecte,

                vede_toate_etapele: uDrepturi.acces_extins_proiecte,
                editeaza_etape: uDrepturi.acces_extins_proiecte,

                gestioneaza_useri: uDrepturi.acces_extins_proiecte,
            }

            console.log('objToInsert :>> ', objToInsert);



            let insert = await fs.insertUserProject(objToInsert)

            if (insert) {
                this.setState({ isOpenInsert: false }, () => {
                    this.fromServer()
                })
            }


        }

        // console.log('objToInsert :', objToInsert);



    }


    changeLevel = (e, ev) => {
        // console.log('e :', e);
        // console.log('ev.target.value :', ev.target.value);

        let cloneUsers = [...this.state.listUsers]

        let idx = cloneUsers.findIndex(i => i.id === e.id)

        cloneUsers[idx].nivel_responsabil = ev.target.value
        this.setState({
            listUsers: cloneUsers
        })
    }

    updateLevel = async (e) => {
        // console.log('e :', e);

        let ws = new Ws();

        let updateLevel = ws.update('proiecte_drepturi', { nivel_responsabil: e.nivel_responsabil }, { id_utilizator: e.id })
        if (updateLevel.Succes) {
            // console.log('nivelUpdate succes :');
        }
    }



    deleteUser = async (us) => {

        let ws = new Ws()

        let updateA = ws.update('angajati', { inactiv: 1 }, { id: us.id })
        let updateAD = ws.update('angajati_departamente', { inactiv: 1 }, { id_angajat: us.id, id_departament: us.id_departament })
        let updateU = ws.update('useri', { inactiv: 1 }, { id: us.id_user })
        let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 1 }, { id_user_bazadate_proprie: us.id_user })

        let [a, ad, u, ulog] = await Promise.all([updateA, updateAD, updateU, updateULog])

        if (a.Succes && u.Succes && ulog.Succes) {

            let deleteU = await ws.update('proiecte_drepturi', { sters: 1 }, { id: us.id_linie })

            if (deleteU.Succes) {
                this.setState({ isOpenNewUser: false }, () => {

                    this.fromServer()
                })
            }
        }

    }



    deleteUserProiect = async (us) => {

        let ws = new Ws()

        let deleteU = await ws.update('proiecte_drepturi', { sters: 1 }, { id: us.id_linie })

        if (deleteU.Succes) {
            this.setState({ isOpenNewUser: false }, () => {

                this.fromServer()
            })
        }
    }


    newUser = async () => {



        let ws = new Ws();
        let u = new Utils()


        let objToInsert = {
            nume: 'Nume Angajat',
            email: '',
            telefon: ''
        }

        let insertUser = await ws.insert('useri', objToInsert)




        if (insertUser.Succes) {

            // console.log('insertUser :', insertUser);
            let iAngajat = await ws.insert('angajati', { nume: objToInsert.nume, id_categorie: 1,data_angajarii: u.updateSqlNow(), id_user: insertUser.Content[0].id })



            if (iAngajat.Succes) {
                // let iDep =await ws.insert('angajati_departamente',{id_angajat:iAngajat.Content[0].id,
                //                                             id_departament:d.id})

                let angajatInfo = {
                    adresa: "",
                    cnp: "",
                    cost_minut: '',
                    email: "",
                    firma: '',
                    functie: "",
                    id: iAngajat.Content[0].id,
                    id_departament: 0,
                    id_user: insertUser.Content[0].id,
                    nume: "",
                    nume_departament: "",
                    oras: "",
                    poza: "",
                    salariu: '',
                    sef_departament: '',
                    telefon: "",
                    access_financiar:'',
                    nr_zile_concediu:'',
                    salariu_moneda:'lei',
                    permis_conducere:''
                }
                this.setState({
                    angajatInfo: angajatInfo,
                    isOpenNewUser: true,
                    toUpdate: false
                }, () => {

                    // let t = { id: insertUser.Content[0].id }
                   
                })
            }

        }


    }

    closeNewUser = async () => {
        let ws = new Ws()

        let updateA = ws.update('angajati', { inactiv: 1 }, { id: this.state.angajatInfo.id })
        let updateU = ws.update('useri', { inactiv: 1 }, { id: this.state.angajatInfo.id_user })
        let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 1 }, { id_user_bazadate_proprie: this.state.angajatInfo.id_user })

        let [a, u, ulog] = await Promise.all([updateA, updateU, updateULog])

        if (a.Succes && u.Succes && ulog.Succes) {
            this.setState({ isOpenNewUser: false })
        }

    }

    changeFirma = (ev) => {
        let angajat = { ...this.state.angajatInfo }

        if (ev.target.checked) {
            angajat.departament = ''
            this.setState({
                angajat: angajat,
                isFirmaExterna: ev.target.checked
            })
        } else {
            angajat.firma = ''
            this.setState({
                angajat: angajat,
                isFirmaExterna: ev.target.checked
            })
        }
    }
    changeData = (ev) => {
        let angajat = { ...this.state.angajatInfo }

        angajat[ev.target.name] = ev.target.value

        this.setState({
            angajatInfo: angajat,
            verifyEmail: ''
        }, () => {
            console.log('this.state.angajatInfo :>> ', this.state.angajatInfo);
        })
    }

    insertNewUser = async () => {
        let ws = new Ws();
        let u = new Utils();



        let _verifyEmail =  ws.customSelect('select * from pm_logator.[dbo].useri where email = @p1 and id_user_bazadate_proprie != @p2 and isnull(inactiv,0) != 1 ', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailUseri =  ws.customSelect('select * from useri where email = @p1 and id != @p2 and isnull(inactiv,0) != 1 ',{
            p1:this.state.angajatInfo.email,
            p2:this.state.angajatInfo.id_user
        })

        let _verifyEmailAngajati =  ws.customSelect('select * from angajati where email = @p1 and id != @p2 and isnull(inactiv,0) != 1 ',{
            p1:this.state.angajatInfo.email,
            p2:this.state.angajatInfo.id
        })

        console.log('verifyEmail :>> ', verifyEmail);

        let [verifyEmail, verifyEmailUseri,verifyEmailAngajati ] = await Promise.all([_verifyEmail,_verifyEmailUseri,_verifyEmailAngajati ])

        if (verifyEmail.Succes) {
            if (verifyEmail.Content.length === 0 && verifyEmailUseri.Content.length === 0 && verifyEmailAngajati.Content.length === 0 && this.state.parola.length >= 5) {


                let objAngajat = {
                    id_categorie: 1,
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    telefon: this.state.angajatInfo.telefon || 0,
                    oras: this.state.angajatInfo.oras || '',
                    adresa: this.state.angajatInfo.adresa || '',
                    cnp: this.state.angajatInfo.cnp || 0,
                    salariu: this.state.angajatInfo.salariu || 0,
                    cost_minut: this.state.angajatInfo.cost_minut || 0,
                    functie: this.state.angajatInfo.functie || '',
                    data_angajarii: u.updateSqlNow(),
                    salariu_moneda:this.state.angajatInfo.salariu_moneda || '',
                    nr_zile_concediu:this.state.angajatInfo.nr_zile_concediu || '',
                    permis_conducere:this.state.angajatInfo.permis_conducere || '',
                }

                let objUser = {
                    token: u.randomData(32),
                    nume: this.state.angajatInfo.nume,
                    email: this.state.angajatInfo.email,

                }

                objUser['firma'] = this.state.angajatInfo.firma || ''
                objUser['firma_externa'] = this.state.isFirmaExterna ? 1 : 0

                if (this.state.isFirmaExterna) {
                    objUser['firma'] = this.state.angajatInfo.firma || ""
                }

                let getSocietate = await ws.customSelect('select * from setari where param_code = @p1', {
                    p1: 'soc_id'
                })

                if (getSocietate.Succes) {

                    let objNewUserLogator = {
                        token: objUser.token,
                        nume: this.state.angajatInfo.nume,
                        id_societate_client: getSocietate.Content[0].val,
                        email: this.state.angajatInfo.email,
                        parola: this.state.parola,
                        parolac: this.state.parola,
                        id_user_bazadate_proprie: this.state.angajatInfo.id_user,
                    }

                    let updateA = ws.update('angajati', objAngajat, { id: this.state.angajatInfo.id })
                    let updateU = ws.update('useri', objUser, { id: this.state.angajatInfo.id_user })

                    let iUserDrepturi = ws.insert('useri_drepturi', {
                        id_utilizator: this.state.angajatInfo.id_user,

                        profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',

                        acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        sterge_proiecte: 0

                    })

                    let insertD = ws.insert('angajati_departamente', {
                        id_angajat: this.state.angajatInfo.id,
                        id_departament: this.state.angajatInfo.id_departament,
                        sef_departament: this.state.angajatInfo.sef_departament || ''
                    })
                    let insertNewUser = ws.insert('pm_logator.[dbo].useri', objNewUserLogator)


                    let [a, u, d, n, iU] = await Promise.all([updateA, updateU, insertD, insertNewUser, iUserDrepturi])

                    console.log('iU :>> ', iU);

                    if (a.Succes && u.Succes && d.Succes && n.Succes) {



                        this.setState({ isOpenNewUser: false }, () => {
                              let t = { id: this.state.angajatInfo.id_user }
                            this.addUser(t)

                            this.fromServer()
                        })
                    }


                    // console.log('insertNewUser :', insertNewUser);

                }






            } else {
                this.setState({
                    verifyEmail: 'Emailul deja exista !',
                    vParola: this.state.parola.length < 5 ? 'Parola trebuie sa aiba minim 5 caractere !' : (this.state.parola === this.state.repetParola ? '' : 'Parolele nu coincid !')
                })
            }

        }
    }

    updateAngajat = async () => {

        let ws = new Ws();
        let u = new Utils();

        let _verifyEmail =  ws.customSelect('select * from pm_logator.[dbo].useri where email = @p1 and id_user_bazadate_proprie != @p2 and isnull(inactiv,0) != 1  ', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailUseri =  ws.customSelect('select * from useri where email = @p1 and id != @p2 and isnull(inactiv,0) != 1 ',{
            p1:this.state.angajatInfo.email,
            p2:this.state.angajatInfo.id_user
        })

        let _verifyEmailAngajati =  ws.customSelect('select * from angajati where email = @p1 and id != @p2 and isnull(inactiv,0) != 1 ',{
            p1:this.state.angajatInfo.email,
            p2:this.state.angajatInfo.id
        })

        console.log('verifyEmail :>> ', verifyEmail);

        let [verifyEmail, verifyEmailUseri,verifyEmailAngajati ] = await Promise.all([_verifyEmail,_verifyEmailUseri,_verifyEmailAngajati ])


        console.log('verifyEmail :>> ', verifyEmail);

        console.log('angajatInfo :>> ', this.state.angajatInfo);

        if (verifyEmail.Succes) {

            if (verifyEmail.Content.length === 0 && verifyEmailUseri.Content.length === 0 && verifyEmailAngajati.Content.length === 0 ) {

                let objAngajat = {
                    id_categorie: 1,
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    telefon: this.state.angajatInfo.telefon || 0,
                    oras: this.state.angajatInfo.oras || '',
                    adresa: this.state.angajatInfo.adresa || '',
                    cnp: this.state.angajatInfo.cnp || 0,
                    salariu: this.state.angajatInfo.salariu || 0,
                    cost_minut: this.state.angajatInfo.cost_minut || 0,
                    functie: this.state.angajatInfo.functie || '',
                    salariu_moneda:this.state.angajatInfo.salariu_moneda || '',
                    nr_zile_concediu:this.state.angajatInfo.nr_zile_concediu || '',
                    permis_conducere:this.state.angajatInfo.permis_conducere || '',

                }

                let objUser = {
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    access_financiar:this.state.angajatInfo.access_financiar || '' 

                }

                let objNewUserLogator;

                if (this.state.parola.length > 3) {

                    objNewUserLogator = {
                        email: this.state.angajatInfo.email,
                        parola: this.state.parola,
                        parolac: this.state.parola,
                        inactiv:0

                    }
                } else {
                    objNewUserLogator = {
                        email: this.state.angajatInfo.email,
                        inactiv:0
                        // parola: this.state.parola,
                        // parolac: this.state.parola,

                    }
                }


                objUser['firma'] = this.state.angajatInfo.firma || ''
                objUser['firma_externa'] = this.state.isFirmaExterna ? 1 : 0

                if (this.state.isFirmaExterna) {
                    objUser['firma'] = this.state.angajatInfo.firma || ''
                }



                let updateA = ws.update('angajati', objAngajat, { id: this.state.angajatInfo.id })
                let updateU = ws.update('useri', objUser, { id: this.state.angajatInfo.id_user })

                let selectDrepturi = await ws.customSelect('select * from useri_drepturi where id_utilizator = @p1', {
                    p1: this.state.angajatInfo.id_user
                })

                let iUserDrepturi

                if (selectDrepturi.Succes) {
                    if (selectDrepturi.Content.length > 0) {
                        console.log('are Drepturi  :>> ', selectDrepturi.Content);

                        iUserDrepturi = ws.update('useri_drepturi', {

                            profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',

                            acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            sterge_proiecte: 0

                        }, { id_utilizator: this.state.angajatInfo.id_user, })
                    } else {
                        iUserDrepturi = ws.insert('useri_drepturi', {
                            id_utilizator: this.state.angajatInfo.id_user,
                            profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',


                            acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            sterge_proiecte: 0

                        })
                    }
                }






                let updateD = ws.update('angajati_departamente', {
                    id_departament: this.state.angajatInfo.id_departament || '',
                    sef_departament: this.state.angajatInfo.sef_departament || ''
                }, { id_angajat: this.state.angajatInfo.id })

                let updateNewUserL = ws.update('pm_logator.[dbo].useri', objNewUserLogator, { id_user_bazadate_proprie: this.state.angajatInfo.id_user, id_societate_client: Number(this.state.societate.val) })

                let [uA, uU, uD, iU, uL] = await Promise.all([updateA, updateU, updateD, iUserDrepturi, updateNewUserL])

                console.log('uA :>> ', uA);
                console.log('uU :>> ', uU);
                console.log('uD :>> ', uD);
                console.log('iU :>> ', iU);
                console.log('uL :>> ', uL);

                if (uA.Succes && uU.Succes && uD.Succes) {
                    this.setState({ isOpenNewUser: false }, () => {
                        this.fromServer()
                    })
                }
            } else {
                this.setState({
                    verifyEmail: 'Emailul deja exista !',
                    vParola: this.state.parola.length < 5 ? 'Parola trebuie sa aiba minim 5 caractere !' : (this.state.parola === this.state.repetParola ? '' : 'Parolele nu coincid !')
                })
            }


        }
    }




    buttonDisabled = () => {

        if (this.state.listUsers.length > 0

        ) {
            return false
        } else {
            return true
        }
    }

    colorButton = () => {
        if (this.state.listUsers.length > 0) {
            return '#07B14B'
        } else {
            return 'gray'
        }
    }


    changeManager = (ev) => {
        let manager = { ...this.state.angajatInfo }

        manager["sef_departament"] = ev.target.checked

        this.setState({ angajatInfo: manager })
    }

    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }

    selectUser = (u) => {

        console.log('u :>> ', u);

        let user = { ...u }

        user.sef_departament = user.sef_departament === 1
        this.setState({
            angajatInfo: user,
            isOpenNewUser: true,
            toUpdate: true,
            isFirmaExterna: u.firma_externa === 1 ? true : false,
        })
    }

    render() {
        return (
            <div>

                <Grid style={{ padding: 20, position: 'relative', backgroundColor: 'white' }} container>
                    <div style={{ position: 'absolute', top: -20, left: 0, right: 0, margin: "auto" }}>
                        {this.getIcons()}
                    </div>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 20, fontWeight: 500, color: 'black', marginBottom: 40 }}>
                            {this.dictionary.proiecte.utilizatoriProiecte}

                        </h4>
                    </Grid>

                    <Grid style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 15 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                        <Grid container>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <div style={{ position: 'relative', height: '100%' }}>
                                    <span style={{
                                        verticalAlign: 'sub',
                                        color: 'black',
                                        fontSize: 14
                                    }}>{this.dictionary.proiecte.selectUsers} </span>
                                </div>

                            </Grid>

                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>

                                {this.state.listUsers.map((u, idx) => {

                                    return (
                                        <div style={{ padding: '10px 0 10px 0', display: 'flex', justifyContent: 'space-between' }} key={idx}>
                                            <div>
                                                {
                                                    u.poza &&
                                                    <div
                                                        onClick={() => { this.selectUser(u) }}
                                                        className='pm-angajati-picture'
                                                        style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + u.poza}')`, width: 36, height: 36 }}>

                                                    </div>
                                                }
                                                {!u.poza &&

                                                    <Avatar
                                                        onClick={() => { this.selectUser(u) }}
                                                        className='pm-angajati-picture'
                                                        style={{ display: 'inline-block', textAlign: 'center', height: 36, width: 36, backgroundColor: new Utils().culoriUtilizatori(u.id) }}>
                                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                        <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(u.nume)} </span>

                                                    </Avatar>
                                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                }
                                                <span onClick={() => { this.selectUser(u) }} className='pm-task-change-user'>{u.nume} {u.firma ? `- ${u.firma}` : ''}</span>
                                            </div>

                                            <i style={{ cursor: 'pointer', verticalAlign: 'middle' }} onClick={() => { this.deleteUserProiect(u) }} className='material-icons'>clear</i>

                                        </div>
                                    )

                                })

                                }

                                {/* <select
                                    className='add-project-input'
                                    type="text"
                                    margin="normal"
                                    value={this.state.userSelectat}
                                    onChange={this.addUser}

                                >

                                    <option value={'0'}>Niciun utilizator selectat</option>
                                    {this.state.listAllUsers.map((l, idx) => {
                                        return (
                                            <option key={idx} value={l.id}>{l.nume} {l.firma ? `- ${l.firma}` : ''}</option>
                                        )
                                    })}

                                </select> */}

                                <div>
                                    <CustomUserMenu
                                        user={this.state.userSelectat}
                                        clearInput={() => {
                                            this.setState({
                                                userSelectat:
                                                    this.state.userSelectat,

                                            })
                                        }}
                                        openList={() => { this.setState({ openList: true }) }}
                                        closeList={() => { this.setState({ openList: false }) }}
                                        showList={this.state.openList}
                                        users={this.state.listAllUsers}
                                        selectUser={this.addUser}
                                        width={'100%'}
                                        label={this.dictionary.proiecte.selectUser}

                                    />
                                </div>




                            </Grid>



                            <Grid style={{ textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                <Button
                                    style={{ backgroundColor: 'rgb(24 165 58 )', textTransform: 'unset' }}
                                    variant="contained"
                                    color="primary" onClick={this.newUser}>
                                    {this.dictionary.proiecte.newUser}
                                </Button>


                            </Grid>


                        </Grid>





                    </Grid>

                </Grid>

                <Grid container style={{ marginTop: 40, textAlign: 'left' }}>
                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button disabled={this.buttonDisabled()}
                            style={{ backgroundColor: this.colorButton(), fontSize: 14, fontWeight: 400, boxShadow: 'none' }}
                            variant="contained"
                            className='next-step-projects'
                            color="primary" onClick={this.props.goToInfoEtape}>
                            {this.dictionary.proiecte.step3Project}
                        </Button>
                    </Grid>

                    <Grid style={{ textAlign: 'right' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button
                            style={{ backgroundColor: 'gray', color: 'white', fontSize: 14, fontWeight: 400, boxShadow: 'none' }}
                            variant="contained"
                            className='next-step-projects'
                            color="primary" onClick={this.props.goToInfoProiect}>
                            {this.dictionary.proiecte.stepBack}
                        </Button>
                    </Grid>
                </Grid>
                <NewUserDrepturi
                    open={this.state.isOpenNewUser}
                    dialogClose={this.state.toUpdate ? () => { this.setState({ isOpenNewUser: false }) } : this.closeNewUser}
                    angajat={this.state.angajatInfo}
                    departamente={this.state.listDepartamente}
                    isFirmaExterna={this.state.isFirmaExterna}
                    changeFirma={this.changeFirma}
                    changeData={(ev) => { this.changeData(ev) }}
                    limba={this.dictionary}
                    vEmail={this.state.verifyEmail}
                    updateAngajat={this.state.toUpdate ? this.updateAngajat : this.insertNewUser}
                    parola={this.state.parola}
                    repetParola={this.state.repetParola}
                    parolaChange={(ev) => { this.setState({ parola: ev.target.value }) }}
                    repetaParolaChange={(ev) => { this.setState({ repetParola: ev.target.value }) }}
                    vParola={this.state.vParola}
                    changeManager={this.changeManager}
                    toUpdate={this.state.toUpdate}
                    stergeAngajat={() => { this.deleteUser(this.state.angajatInfo) }}
                    getData={() => { this.fromServer(this.state.angajatInfo) }}
                    openProgram={() => { this.setState({ isOpenProgram: true }) }}
                    noProgram={true}
                    noDrepturi={true}
                />

                {/* <div className='container'>

                    <div style={{ border: '1px solid #d4d4d4', padding: 5 }}>
                        <div style={{ textAlign: "center", marginBottom: 5, padding: 15, }}>
                            <Button onClick={this.newUser} className="pm-edit-button">
                                <i className='material-icons pm-round-button-text'>add</i>
                            Adauga Utilizator nou
                    </Button>

                        </div>
                        <div style={{ textAlign: "center", marginBottom: 20, padding: 15, }}>
                            <Button style={{ marginLeft: 10, }} onClick={() => { this.setState({ isOpenInsert: true }) }} className="pm-adauga-button">
                                <i className='material-icons pm-round-button-text'>add</i>
                            Adauga Utilizatori existenti
                    </Button>

                        </div>

                      

                        {this.state.listUsers.length > 0 &&

                            <UsersListDrepturi
                                elemente={this.state.listUsers}
                                dict={this.dictionary}
                                onlyColumns={{
                                    nume: 'nume',
                                    doar_citire: 'doar_citire',
                                    drepturi_extinse: 'drepturi_extinse',
                                    poza: 'poza',
                                    nivel_responsabil: 'nivel_responsabil',
                                    color_responsabil: 'color_responsabil'
                                }}
                                onElClick={this.userClick}
                                nivelResponsabilitate={this.state.listNivelResponsabil}
                                handleCitire={this.changeCitire}
                                handleExtins={this.changeExtins}
                                levelChange={this.changeLevel}
                                updateLevel={this.updateLevel}
                                displayDelete={this.state.displayDelete}
                                deleteUser={this.deleteUser}
                            />
                        }


                    </div>
                    <AddUserDrepturi
                        dialogDisplay={1}
                        open={this.state.isOpenInsert}
                        dialogClose={() => { this.setState({ isOpenInsert: false }) }}
                        title={this.dictionary.appBar.buttons.insertUser}
                        limba={this.dictionary}
                        listUsers={this.state.listAllUsers}
                        userClick={this.addUser}
                    />

                </div> */}


            </div>
        );
    }
}